import { ModelBase } from "../base"
import { QuestionnaireQuestionContentModel } from "./content"
import { QuestionnaireQuestionOptionModel } from "./option"
import { QuestionnaireQuestionOptionContentModel } from "./option-content";

export const QuestionType = {
    None: -1,
    YesNo: 1,
    Multiple: 2,
    Rating: 3
}

export class QuestionnaireQuestionModel extends ModelBase {
    id = 0;
    questionnaireSectionId = 0;
    rank = 0;
    questionType = QuestionType.None;
    questionContent = [
        new QuestionnaireQuestionContentModel({
            question: "New Question",
        })
    ]
    questionOptions = [
    ]

    constructor(params) {
        super();
        this.mapModel(params);

        this.content = [
            new QuestionnaireQuestionContentModel()
        ]
    }

    setQuestionType() {
        switch(this.questionType) {
            case QuestionType.YesNo: {
                this.questionOptions = [
                    new QuestionnaireQuestionOptionModel({
                        answerBool: true,
                        answerText: "YES",
                        optionContent: [
                            new QuestionnaireQuestionOptionContentModel({
                                optionText: "YES"
                            })
                        ]
                    }),
                    new QuestionnaireQuestionOptionModel({
                        answerBool: false,
                        answerText: "NO",
                        optionContent: [
                            new QuestionnaireQuestionOptionContentModel({
                                optionText: "NO"
                            })
                        ]
                    })
                ]
            }break;
            case QuestionType.Multiple: {
                this.questionOptions = [
                    new QuestionnaireQuestionOptionModel()
                ]
            }break;
            case QuestionType.Rating: {
                this.questionOptions = [
                    new QuestionnaireQuestionOptionModel()
                ]
            }break;
        }
    }
}

export class QuestionnaireQuestionCreateModel extends ModelBase {
    id = 0;
    questionnaireSectionId = 0;
    questionType = 1;
    rank = 0;
    questionContent = [
        new QuestionnaireQuestionContentModel({
            question: "New Question"
        })
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}